import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

interface DocumentDetailsResponse {
  id: number;
  image: string;
  title: string;
  title_malay: string;
  title_mandarin: string;
  redirect_url: string;
  published: boolean;
  field_banner_created_at: string;
  field_banner_updated_at: string;
  eraman_sync: boolean;
  corporate_sync: boolean;
  passenger_sync: boolean;
  magp_sync: boolean;
  web_image: string;
  passenger_langkawi: string;
  passenger_kota_kinabalu: string;
  passenger_kuching: string;
  passenger_klia1: string;
  passenger_klia2: string;
  passenger_penang: string;
  eraman_langkawi: string;
  eraman_kota_kinabalu: string;
  eraman_penang: string;
  eraman_kuching: string;
  eraman_klia1: string;
  eraman_klia2: string;
  end_date: string;
  start_date: string;
  type: any;
  tag: any;
  project_airport_id: any;
  sequence: string;
  tab_image: string;
  video: string;
  created_by: string;
  last_modified_by: string;
}

const fetchCentralisedBannerDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/homepage-banner/all-fields/${id}`);
  return response.data[0];
};

const useCentralisedBannerDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["centralisedBanner", id],
      enabled: false,
      queryFn: () => {
        return fetchCentralisedBannerDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useCentralisedBannerDetails };
